module.exports = __webpack_public_path__ + "img/e_1_6_g.41757b5c.png";